export type SimClocks = {
  break: number;
  drive: number;
  shift: number;
  cycle: number;
};

export type RouteBuddyDriverStatus = {
  eldDriverId: number;
  firstName: string;
  lastName: string;
  eldVehicleId: number;
  eldVehicleUnitNumber: string;
  dutyStatus: string;
  clocks: SimClocks;
  currentOffStreak: number;
  lat: number | null;
  lng: number | null;
  locationSource: 'device' | 'eventLine' | 'none';
  locationAt: string | null;
};

export type SimLeg = {
  miles: number;
  durationHours: number;
};

export type SimSegmentType = 'DRIVE' | 'BREAK_30M' | 'REST_10H' | 'RESTART_34H' | 'WAIT' | 'DWELL';

export type SimSegment = {
  type: SimSegmentType;
  from: string;
  to: string;
  hours: number;
  miles: number;
  startFraction: number;
  endFraction: number;
  comment: string;
};

export type SimDay = {
  date: string;
  driveHours: number;
  onDutyHours: number;
  restHours: number;
  miles: number;
};

export type SimStopResult = {
  stopIndex: number;
  label: string;
  arrival: string;
  departure: string;
  canMakeAppointment: boolean | null;
  slackHours: number | null;
  clocksAfter: SimClocks;
};

export type RouteBuddySimulateResponse = {
  segments: SimSegment[];
  days: SimDay[];
  stopResults: SimStopResult[];
  totalMiles: number;
  totalDriveHours: number;
  usedCycleRestart: boolean;
  clocksAtStart: SimClocks;
  verificationPassed: boolean;
  warnings: string[];
  timezone: string;
};

export type LatLngLiteral = {
  lat: number;
  lng: number;
};

export type StopLocation = {
  address: string;
  lat: number | null;
  lng: number | null;
};

export type StopLabel = 'PICKUP' | 'DELIVERY';

export type TripStop = {
  key: number;
  label: StopLabel;
  location: StopLocation;
  appointmentAt: string | null;
  dwellHours: number;
  departAt: string | null;
  // present on stops restored from a saved trip file, for planned-vs-actual comparison
  plannedArrival?: string | null;
  plannedDeparture?: string | null;
  done?: boolean;
};

// the downloadable trip file
export type SavedTrip = {
  version: 1;
  savedAt: string;
  eldDriverId: number;
  driverName: string;
  origin: StopLocation;
  tripDepartAt: string | null;
  plannedDepartAt: string;
  stops: {
    label: StopLabel;
    address: string;
    lat: number;
    lng: number;
    appointmentAt: string | null;
    dwellHours: number;
    departAt: string | null;
    plannedArrival: string;
    plannedDeparture: string;
  }[];
};

// what the dispatcher is currently placing with a map click
export type PickTarget = 'origin' | number | null;

export const EMPTY_STOP_LOCATION: StopLocation = { address: '', lat: null, lng: null };

let stopKeyCounter = 1;

export function newTripStop(label: StopLabel): TripStop {
  stopKeyCounter += 1;
  return {
    key: stopKeyCounter,
    label,
    location: EMPTY_STOP_LOCATION,
    appointmentAt: null,
    dwellHours: 1,
    departAt: null,
  };
}

export const STOP_LABELS: Record<StopLabel, string> = {
  PICKUP: 'Pickup',
  DELIVERY: 'Delivery',
};
